import styled from 'styled-components/macro';
import { SM  } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';


const {
  media_sm
} = variables;

export const Reason = styled.div`
  display: flex;
  margin-top: 20px;
`

export const StyledChooseOurCompany = styled.div`
  width: 100%;
  max-width: 1000px;
  position: relative;
  margin: 0 auto;
  svg {
    height: 60px;
  }
  .shield {
    display: none;
  }
  @media ${media_sm} {
   .shield {
      display: block;
    }
  }
`


export const Dot = styled.span`
  position: relative;
  width: 11px;
  height: 11px;
  min-width: 11px;
  min-height: 11px;
  background: #b7ccfa;
  border-radius: 100%;
  display: inline-block;
  margin-right: 15px;
  margin-top: 8px;
`


export const IntroText = styled(SM)`
  position: absolute;
  left: -113px;
  right: 0px;
  margin: 0px auto;
  width: 89px;
  top: -15px;
  z-index: 3;
  padding-left: 0;
  font-size: 11px;
  letter-spacing: 0.8px;
  color: #21437b8c !important;
  font-size: 15px !important;
`
export const Image = styled.div`
  box-shadow: 0px -15px 0px 12px #ffffff; 
  background: #fff;   
  position: relative;
  margin: 0 auto;
  display: block;
  max-width: 371px;
  svg {
    max-width: 100%;
    max-height: 214px;
  }
  @media(max-width: 600px) {
    max-width: 170px;
  }
`

export const Line = styled.div`
  position: absolute;
  top: 50%;
  margin-top: -1px;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.16);
  height: 1px;
  &:before {
    content: "";
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
    max-width: 279px;
    background: #fff;
    height: 2px;
    @media(max-width: 600px) {
      max-width: 200px;
    }
  }
`

